module.exports = __webpack_public_path__ + "img/zhengshu2.873fb025.png";